import {
  IField,
  ISelect,
  ISelectOption,
} from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { SwitcherOption } from './model/switcher-option.interface';
import { SwitcherProps } from './model/switcher-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';
import { SelectOptionsState } from '../select/model';
import {
  isSelectShouldBeHidden,
  isSelectShouldBeHidden$,
} from '../select/select.utils';

/**
 * Map slist options to switcher options
 *
 * @param options
 */
function getSwitcherOptions(options: ISelectOption[]): SwitcherOption[] {
  return options.map(option => ({
    text: option.$,
    value: option.$key,
    icon: option.$spritesvg === 'yes' ? option.$sprite : '',
  }));
}

/**
 * Get props for switcher field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 * @param custom - custom options for switcher
 */
export function getSwitcherProps(
  control: ISelect,
  field: IField,
  state: ISPFormState,
  custom?: SelectOptionsState,
): SwitcherProps {
  const selectOptions: SelectOptionsState = custom || {
    get: () => state.selectService.getOptionsForSelect(control.$name),
    stream$: state.selectService.getOptionsForSelect$(control.$name),
  };

  const options = selectOptions.get() || [];
  const options$ = selectOptions.stream$.pipe(map(option => option || []));

  return {
    originalControl: control,
    originalField: field,
    options$,
    optionsUi$: options$.pipe(map(getSwitcherOptions)),
    isHidden: isSelectShouldBeHidden(state, control, field, options),
    isHidden$: isSelectShouldBeHidden$(state, control, field, options$),
  };
}
/**
 * Get config for switcher field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 * @param custom - custom options for switcher
 */
export function getSwitcherConfig(
  control: ISelect,
  field: IField,
  state: ISPFormState,
  custom?: SelectOptionsState,
): ISPFieldConfig<ISPFieldType.Switcher> {
  const props = getSwitcherProps(control, field, state, custom);

  return {
    key: control.$name,
    type: ISPFieldType.Switcher,
    wrappers: [ISPFieldWrapper.FieldBase],
    props,
  };
}
